module.exports = __webpack_public_path__ + "static/img/electrikmex.1059548.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/electrikmex.png
// module id = Kayg
// module chunks = 1